import React from 'react';

export default ({ title = window.APP_TITLE, className = '' }) =>
  (<div className={`text-center m-t-2 m-b-4 ${className}`}>
    <h3>{title}</h3>
    <hr className="heading" />
  </div>)